<template>
    <li>
        <a
            :href="updateItem.webUrl"
            :target="updateItem.urlTarget"
            :alt="updateItem.name"
        >
            <div class="update-item__divider">
                <span v-if="updateItem.thema" class="pr-1 font-weight-bold">
                    {{ updateItem.label }} -
                    {{ updateItem.thema }}
                </span>
                <span class="small">
                    {{ updateItem.lastModifiedDate }}
                </span>
            </div>
            <span>{{ updateItem.name }}</span></a
        >
    </li>
</template>

<script>
export default {
    props: {
        updateItem: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>

<style lang="scss">
.update-item__wrapper li {
    background-color: $brand-white;
    padding: 10px 20px;
    margin: 0 -20px;

    &:nth-child(odd) {
        background-color: $brand-gray;
    }

    &:hover {
        background-color: $brand-blue;
        cursor: pointer;
    }
}

.update-item__divider {
    border-bottom: dashed 1px $brand-black;
}
</style>
